import { isNonNullable } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { GraphApp } from 'components/Graph/GraphApp/GraphApp';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { GraphDeviceView } from 'components/Graph/GraphDeviceView';
import { GraphNodeContextMenu } from 'components/Graph/GraphNodeContextMenu';
import { GraphTopControls } from 'components/Graph/GraphTopControls';
import { flow } from 'fp-ts/lib/function';
import { type FC, useRef } from 'react';
import { GraphEdgeContextMenu } from './GraphEdgeContextMenu';
import { GraphLayoutDialog } from './GraphLayout/GraphLayoutDialog';
import { GraphTooltip } from './GraphTooltip/GraphTooltip';

export const LoadedGraph: FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const ctxProps = useGraphContextSelectors({
    deviceViewContainer: prop('deviceViewContainer'),
    dispatch: prop('dispatch'),
    graph: prop('graph'),
    pathlookup: prop('pathlookup'),
    showGraphLayoutDialog: flow(prop('graphLayoutDialog'), isNonNullable),
    showEdgeContextMenu: (s) => s.edgeContextMenu !== null,
    showNodeContextMenu: (s) => s.nodeContextMenu !== null,
  });

  return (
    <div
      className='relative flex flex-1 flex-col overflow-hidden'
      ref={ctxProps.deviceViewContainer}
    >
      <div
        className='relative flex flex-1 flex-row overflow-hidden'
        ref={containerRef}
      >
        <GraphApp />
        <GraphTopControls />
        <GraphTooltip container={containerRef.current} />
        {ctxProps.showEdgeContextMenu && (
          <GraphEdgeContextMenu container={containerRef.current} />
        )}
        {ctxProps.showNodeContextMenu && (
          <GraphNodeContextMenu container={containerRef.current} />
        )}
        {ctxProps.showGraphLayoutDialog && <GraphLayoutDialog />}
      </div>
      <GraphDeviceView windowContainer={containerRef.current} />
    </div>
  );
};
